/**
 * Component registry for landing-page theme
 * 
 * Maps component slots to actual implementations.
 */

import type { ComponentRegistry } from '@vibesites/runtime';

// Import custom components
import {
  Header,
  Hero,
  SpecialOffers,
  SectionNav,
  PropertyOverview,
  FloorPlansList,
  AmenitiesList,
  Fees,
  NeighborhoodMap,
  CTASection,
  Footer,
  ThankYouHero,
  ThankYouMap,
} from './components';

export const registry: ComponentRegistry = {
  // Header & Navigation
  Header: Header,
  Navigation: SectionNav,
  MobileDrawer: null, // Handled within Header component
  
  // Hero
  Hero: Hero,
  PageHero: Hero,
  
  // Main content sections
  PropertyOverview: PropertyOverview,
  FloorplansList: FloorPlansList,
  AmenitiesList: AmenitiesList,
  Fees: Fees,
  NeighborhoodMap: NeighborhoodMap,
  
  // Special sections
  SpecialOffers: SpecialOffers,
  PetPolicy: null, // Included in Fees component
  
  // CTAs
  CTASection: CTASection,
  CTAButton: null, // Handled within other components
  
  // Gallery & Tours
  Gallery: null, // Included in PropertyOverview slider
  VirtualTourEmbed: null, // Not used in this theme
  
  // Contact & Footer
  ContactForm: null, // Embedded in Hero component
  OfficeHours: null, // Included in Footer
  SocialHub: null, // Included in Footer
  Footer: Footer,
  
  // Thank You page
  ThankYouHero: ThankYouHero,
  ThankYouMap: ThankYouMap,

  // Other (not used in this single-page theme)
  Reviews: null,
  Spacer: null,
  Divider: null,
  RichText: null,
};
